<template lang="pug">
  .waveline
    img.waveline-1(v-show="waveState" src="~assets/tutorial/waveline1.png")
    img.waveline-2(v-show="!waveState" src="~assets/tutorial/waveline2.png")

</template>
<script>
import * as THREE from 'three'
import {mapState, mapMutations} from 'vuex'
import {TweenMax, TimelineMax, Power3} from 'gsap'

export default {
  name: "Logo",
  props: {

  },
  components: {},
  data() {
    return {
      waveState: false,
      p: 0
    }
  },
  computed:{
    ...mapState('app', ['mode']),
  },
  methods: {

    init() {},
    animate() {
      let tl = new TimelineMax({
        onComplete: ()=> {
          this.waveState = !this.waveState
        },
        repeat: -1
      })
      this.tl = tl

      tl.add('start')
        .set(
          this,
          {
            waveState: false
          }
        )
        .to(
          this,
          0.2,
          {
            p: 1,
          },
          `start+=0`
        )
        .set(
          this,
          {
            waveState: true
          }
        )
        .to(
          this,
          0.2,
          {
            p: 0,
          },
          `start+=0.2`
        )

    },
  },
  mounted() {
    this.init()
    this.animate()
  },
  beforeDestroy(){

  },
  watch: {

  }
}
</script>


<style lang="sass" scoped>
  @import "src/styles/common.sass"
  .waveline
    //background: greenyellow
    line-height: 0
    // z-index: 10
    pointer-events: none
    //background: #3a54a2

    img
      //background: #ffd81b
      display: block
      width: 100%
      position: absolute
      top: 0
      left: 0


</style>